import { Button, Link, Logo, Navigation } from 'components'
import PropTypes from 'prop-types'
import React, { useEffect, useState, useCallback, forwardRef } from 'react'
import { RiLoginCircleLine } from 'react-icons/ri'
import * as Styles from './Header.module.css'

import { useWindowDimensions } from 'hooks'

const Header = forwardRef(
  ({ showNavigation, showButtons, navHeight, websiteWrapper }, ref) => {
    const [navState, setNavState] = useState(false)
    const { windowWidth } = useWindowDimensions() || {}

    const smallWindow = windowWidth < 1280

    const handleToggleNavigation = () => {
      if (!navState && smallWindow) {
        websiteWrapper.current.style.height = '100vh'
        websiteWrapper.current.style.overflowY = 'hidden'
      } else {
        websiteWrapper.current.style.height = 'auto'
        websiteWrapper.current.style.overflowY = 'initial'
      }

      setNavState(!navState)
    }

    const handleClose = () => {
      setNavState(false)
    }

    const handleResize = useCallback(() => {
      if (smallWindow) {
        setNavState(false)
        return
      }

      setNavState(true)
    }, [smallWindow])

    const handleKeyDown = useCallback(
      (e) => {
        if (navState && e.key === 'Escape') {
          handleClose()
        }
      },
      [navState]
    )

    const handleScroll = useCallback(
      (e) => {
        if (navState && !smallWindow) {
          e.preventDefault()
          e.stopPropagation()
        }
      },
      [navState, smallWindow]
    )

    useEffect(() => {
      window.addEventListener('scroll', handleScroll)
      window.addEventListener('keydown', handleKeyDown)
      window.addEventListener('resize', handleResize)
      return () => {
        window.removeEventListener('scroll', handleScroll)
        window.removeEventListener('keydown', handleKeyDown)
        window.removeEventListener('resize', handleResize)
      }
    }, [navState, handleScroll, handleKeyDown, handleResize])

    return (
      <header
        className={`${Styles.header} ${
          navState && smallWindow && Styles.fixedHeader
        }`}
      >
        <div ref={ref}>
          <div className={`${Styles.wrapper}`}>
            <Link to="/" onClick={handleClose}>
              <Logo className={Styles.logo} width={8 * 20} color="primary" />
            </Link>

            <Navigation
              navHeight={navHeight}
              smallWindow={smallWindow}
              navState={navState}
              showNavigation={showNavigation}
              parent={ref}
              handleClose={handleClose}
              handleToggleNavigation={handleToggleNavigation}
            />

            {showButtons && (
              <div className={Styles.buttons}>
                <Button
                  type="text"
                  icon={<RiLoginCircleLine />}
                  to="https://app.leadboxer.com/"
                >
                  Sign in
                </Button>
                <Button type="light" to="/start">
                  Start Trial
                </Button>
                <Button type="primary" to="/demo">
                  Request Demo
                </Button>
              </div>
            )}
          </div>
        </div>
      </header>
    )
  }
)

Header.propTypes = {
  showNavigation: PropTypes.bool,
  showButtons: PropTypes.bool,
}

export default Header
